import { BaseController, BaseState } from '../../common/controllers/BaseController';
import { SecondaryNav } from '../../layout/components/SecondaryNav';
import { bind } from '../../common/utils/decorators';
import { t } from 'i18next';
import { Divider, Paper, Stack, Typography } from '@mui/material';
import AIcon from '../../assets/images/wai-a-wcag-2.1.svg';
import AAIcon from '../../assets/images/wai-aa-wcag-2.1.svg';
import { Interpolation } from '../../config/i18n/components/Interpolation';

type Props = {};

type State = BaseState;

export class AccessibilityStatementController extends BaseController<Props, State> {
  render() {
    return this.renderBase(
      <SecondaryNav title={t('accessibilityStatement.title')} getBreadcrumbs={this.getBreadcrumbs}>
        <Paper sx={{ px: 4.5, py: 5.5 }}>
          <Typography variant="body1">{t('accessibilityStatement.aqtiveGuardCommitment')}</Typography>
          <Typography variant="body1" sx={{ lineHeight: 2 }} component="div">
            <ul style={{ paddingInlineStart: '1.5rem' }}>
              <li>{t('accessibilityStatement.accessibilityLevels')}</li>
              <li>{t('accessibilityStatement.aqtiveGuardLevel')}</li>
              <li>{t('accessibilityStatement.aqtiveGuardMonitoring')}</li>
            </ul>
          </Typography>
          <Stack direction="row" gap={2.25}>
            <AIcon title={t('a11y.accessibilityStatement.aIcon')} />
            <AAIcon title={t('a11y.accessibilityStatement.aaIcon')} />
          </Stack>
          <Divider sx={{ my: 3 }} />
          <Typography variant="body1">{t('accessibilityStatement.aqtiveGuardCTA')}</Typography>
          <Interpolation
            i18nKey={'accessibilityStatement.emailUsAt'}
            items={[{ name: 'anchor', tabIndex: 0, href: `mailto:aqg-accessibility@sandboxquantum.com` }]}
            values={{ email: 'aqg-accessibility@sandboxquantum.com' }}
            variant="body1"
          />
        </Paper>
      </SecondaryNav>
    );
  }

  @bind
  private getBreadcrumbs() {
    return this.breadcrumbFactory.getAccessibilityStatementBreadcrumbs();
  }
}
